import React, { createContext, useState } from 'react'

export interface SurveyModalContextType {
  status: boolean
  setSurveyModalStatus: (status: boolean) => void
  selectedModel: string
  setSelectedModel: (status: string) => void
  selectedProviderId: string
  setSelectedProviderId: (status: string) => void
  filterStatus: boolean
  setFilterStatus: (status: boolean) => void
}

const defaultValues: SurveyModalContextType = {
  status: false,
  setSurveyModalStatus: () => {},
  selectedModel: '',
  setSelectedModel: () => {},
  selectedProviderId: '',
  setSelectedProviderId: () => {},
  filterStatus: false,
  setFilterStatus: () => {},
}

export const SurveyModalContext =
  createContext<SurveyModalContextType>(defaultValues)

const SurveyModalProvider = ({ children }: { children: React.ReactNode }) => {
  const [status, setSurveyModalStatus] = useState<boolean>(false)
  const [selectedModel, setSelectedModel] = useState<string>('')
  const [selectedProviderId, setSelectedProviderId] = useState<string>('')
  const [filterStatus, setFilterStatus] = useState<boolean>(false)

  return (
    <SurveyModalContext.Provider
      value={{
        status,
        setSurveyModalStatus,
        filterStatus,
        setFilterStatus,
        selectedModel,
        setSelectedModel,
        selectedProviderId,
        setSelectedProviderId,
      }}
    >
      {children}
    </SurveyModalContext.Provider>
  )
}

export default SurveyModalProvider
